import React from "react";
import {
  Route,
  Switch,
  useRouteMatch,
} from "react-router-dom/cjs/react-router-dom.min";

import Dashboard from "./Reports/Dashboard";

import SubjectReport from "./Reports/SubjectReport";
import StudentReport from "./Reports/StudentReport";
import TeacherReport from "./Reports/TeacherReport";
import SpecialReport from "./Reports/SpecialReport";
import StudentProgress from "./Reports/StudentProgress/StudentProgress";

import AssignmentSubmissionReport from "./Reports/AssignmentReports/AssignmentSubmissionReport";
import AssignmentReportByTeacher from "./Reports/AssignmentReports/AssignmentReportByTeacher";
import AssignmentReportBySubject from "./Reports/AssignmentReports/AssignmentReportBySubject";

import CategoryReport from "./Reports/EventReports/CategoryReport";
import TagReport from "./Reports/EventReports/TagReport";

import FeedbackReport from "./Reports/FeedbackReports/FeedbackReport";
import { useChartContext } from "../../context/ChartContext";
import TeacherDataReport from "./Reports/TeacherDataReport/TeacherDataReport";
import AttendanceAiInsights from "./Reports/AttendanceAiInsights/AttendanceAiInsights";
import AssignmentAiInsights from "./Reports/AssignmentAiInsights/AssignmentAiInsights";
import EventAiInsights from "./Reports/EventAiInsights/EventAiInsights";
import FeedbackAiInsights from "./Reports/FeedbackAiInsights/FeedbackAiInsights";
import AssignmentSpecialReport from "./Reports/AssignmentSpecialReport/AssignmentSpecialReport";

const ChartRouter = (data) => {
  const { reportOptions, selectedReportPath, setSelectedReportPath } =
    useChartContext();
  let { path } = useRouteMatch();

  const formattedReports = reportOptions?.length
    ? reportOptions.flatMap(({ reports }) => reports)
    : [];

  let reports = [
    {
      ReportComponent: SubjectReport,
      mainPath: "attendance-report-by-subject",
    },
    {
      ReportComponent: StudentReport,
      mainPath: "attendance-report-by-student",
    },
    {
      ReportComponent: TeacherReport,
      mainPath: "attendance-report-by-teacher",
    },
    {
      ReportComponent: SpecialReport,
      mainPath: "attendance-special-report",
    },
    {
      ReportComponent: StudentProgress,
      mainPath: "attendance-student-progress-report",
    },
    {
      ReportComponent: TeacherDataReport,
      mainPath: "attendance-teacher-data-report",
    },
    {
      ReportComponent: AttendanceAiInsights,
      mainPath: "attendance-ai-insights",
    },
    {
      ReportComponent: AssignmentReportBySubject,
      mainPath: "assignment-report-by-subject",
    },
    {
      ReportComponent: AssignmentSubmissionReport,
      mainPath: "assignment-report-by-student",
    },
    {
      ReportComponent: AssignmentReportByTeacher,
      mainPath: "assignment-report-by-teacher",
    },
    {
      ReportComponent: AssignmentSpecialReport,
      mainPath: "assignment-special-report",
    },
    {
      ReportComponent: AssignmentAiInsights,
      mainPath: "assignment-ai-insights",
    },
    {
      ReportComponent: CategoryReport,
      mainPath: "event-report-by-category",
    },
    {
      ReportComponent: TagReport,
      mainPath: "event-report-by-tag",
    },
    {
      ReportComponent: EventAiInsights,
      mainPath: "event-ai-insights",
    },
    {
      ReportComponent: FeedbackReport,
      mainPath: "feedback-report",
    },
    {
      ReportComponent: FeedbackAiInsights,
      mainPath: "feedback-ai-insights",
    },
  ];

  return (
    <>
      {selectedReportPath &&
        reports
          .filter(({ mainPath }) => mainPath === selectedReportPath)
          .map(({ ReportComponent, mainPath }) => (
            <ReportComponent
              key={mainPath}
              {...data}
              setSelectedReportPath={setSelectedReportPath}
              mainPath={selectedReportPath}
            />
          ))}

      {!selectedReportPath && <Dashboard {...data} />}
    </>
  );
};

export default ChartRouter;
